import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["displayName", "hubSpotUserEmail", "size"];
import { Component } from 'react';
import { DEFAULT_PROPS } from './Constants';
import { AvatarDisplay } from './AvatarDisplay';
import { getUnauthedHubSpotUserAvatarUrl } from './lib/getUnauthedHubSpotUserAvatarUrl';
import { AVATAR_SOURCES } from './lib/AvatarSources';
import { jsx as _jsx } from "react/jsx-runtime";
export class UnauthedHubSpotUserAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: undefined
    };
  }
  componentDidMount() {
    if (!this.props.hubSpotUserEmail) {
      return;
    }
    const imageURI = getUnauthedHubSpotUserAvatarUrl({
      hubSpotUserEmail: this.props.hubSpotUserEmail,
      size: this.props.size
    });
    return this.setState({
      imgSrc: imageURI
    });
  }
  render() {
    const _this$props = this.props,
      {
        displayName,
        hubSpotUserEmail,
        size
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AvatarDisplay, Object.assign({
      size: size,
      displayName: displayName || hubSpotUserEmail,
      src: this.state.imgSrc,
      type: "contact",
      source: AVATAR_SOURCES.HUBSETTINGS_HUBSPOT_USER
    }, rest));
  }
}
UnauthedHubSpotUserAvatar.defaultProps = {
  size: DEFAULT_PROPS.size
};